export default {"src":"/_next/static/media/download-app-android.928ad809.svg","height":40,"width":135,"blurWidth":0,"blurHeight":0};